import { render } from "./VersorgungAccordion.vue?vue&type=template&id=79e2a90e&scoped=true"
import script from "./VersorgungAccordion.vue?vue&type=script&lang=js"
export * from "./VersorgungAccordion.vue?vue&type=script&lang=js"

import "./VersorgungAccordion.vue?vue&type=style&index=0&id=79e2a90e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e2a90e"]])

export default __exports__